import NotFound404Svg from '@assets/images/svg/404.svg';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface NotFound404IconProps {
    size?: number;
    color?: string;
}

/**
 * NotFound404Icon - Complete 404 icon with two "4"s, globe, and alert triangle
 * Used for 404 error pages
 */
export function NotFound404Icon({ 
    size = 418, 
    color = '#CCCCCC'
}: NotFound404IconProps) {
    // Calculate height to maintain aspect ratio (418:197)
    const height = (size * 197) / 418;
    
    return (
        <View style={[styles.container, { width: size, height }]}>
            <NotFound404Svg
                width={size}
                height={height}
                color={color}
            />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});

